// CONSTANTS are all caps.
const NS = "ChatbotButton";
const CLS = "chatbotButton";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/chatbotButton.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class ChatbotButton {

	constructor($el) {
		// $el is the widget node return by the loadChatbotButton function
		this.$el = $($el);
	}

	init() {
		console.log(NS, "init");
		this.setChatbotButton();
		this.handleBtnClick();
	}

	//check if page is scrolled so it can move together with the "back to top" button
	setChatbotButton() {
		let $wg = this.$el;
		const clsHasScrolled = 'has-scrolled';

		$(window).on('scroll', () => {
			if($(window).scrollTop() > 100) {
				$wg.addClass(clsHasScrolled);
			} else {
				$wg.removeClass(clsHasScrolled);
			}
		});
	}

	handleBtnClick() {
		let $happytalkBtn = this.$el.find('.chatbotButton-btn--happytalk');
		$happytalkBtn.on('click', (e) => {
			e.preventDefault();
			let url = $happytalkBtn.prop('href');
			window.open(url, 'Window Name', 'height=503,width=350');
		});
	}

}
